<template>
  <div v-if="!selectedCompanies.length" class="rm-screen">
    <div class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("no_companies_selected") }}
    </div>
  </div>
  <report-mobile-shift-rows
    v-else
    :loading="loading"
    :rows="rows"
    :stats="stats"
    :search="filters.search"
    empty-icon="mdi-food-off"
  ></report-mobile-shift-rows>
</template>

<script>
import ReportTabGroupMealsTabMeals from "@/components/report/group-meals/ReportTabGroupMealsTabMeals.vue";
import { SHIFTS } from "@/constants/shifts";
import hasBarShifts from "../../../shared/hasBarShifts";
import hasShiftSubtitle from "../../../shared/hasShiftSubtitle";
import ReportMobileShiftRows from "../../ReportMobileShiftRows.vue";

/**
 * Mobilni "Jela" (jela iz grupa): jelo sa ukupnim brojem obroka i brojem po smeni, redom iz izveštaja (po grupi
 * jela). Firme (grupe), smene i period su u zaglavlju, pretraga u lupi. Nasleđuje učitavanje, štampu i Excel iz
 * starog taba.
 */
export default {
  name: "GroupMobileMeals",
  extends: ReportTabGroupMealsTabMeals,
  mixins: [hasBarShifts, hasShiftSubtitle],
  components: { ReportMobileShiftRows },
  computed: {
    rows() {
      const named = this.foods.map((meal) => ({ ...meal, name: this.toLatin(meal.meal_name) }));
      const found = this.filters.search ? this.customSearch(named, [{ value: "name" }], this.filters.search) : named;
      return found
        .filter((meal) => meal.quantity > 0)
        .map((meal) => ({
          key: String(meal.id),
          name: meal.name,
          total: meal.quantity,
          shifts: SHIFTS.map((shift) => ({ id: shift.id, quantity: meal[shift.key] || 0 })).filter((shift) => shift.quantity > 0),
        }));
    },
    stats() {
      return [
        { key: "total", label: this.$t("report_desktop.total_dishes"), value: this.rows.reduce((sum, row) => sum + row.total, 0) },
        { key: "meals", label: this.$t("meals_main"), value: this.rows.length },
      ];
    },
  },
};
</script>
